// @flow

import gql from 'graphql-tag';

export default gql`
  fragment serviceInfo on Service {
    id
    key: id
    name
    slug
  }
`;

export type ServiceInfoType = {
  id: string,
  key: string,
  name: string,
  slug: string,
};
